import React, { Component } from 'react'
import { Divider } from 'material-ui'

export class Index extends Component {
  render() {
    return (
      <Divider />
    )
  }
}



// WEBPACK FOOTER //
// ./src/index/components/Index.js